export default __webpack_public_path__ + "static/media/Shape.4c566c2a.svg";